var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgW3CssOfficial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-193.633 -548.36217)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.46875001 0 0 0.46875001 194.74253 548.36217)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "107.644,470.877 74.633,100.62 437.367,100.62 404.321,470.819 255.778,512",
    fill: "#264de4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.03,447.246 404.27,130.894 256,130.894 256,480.523",
    fill: "#2965f1"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.31,268.217 154.38,313.627 256,313.627 256,268.217",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.26,221.716 256,221.716 256,176.305 142.132,176.305",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.791,433.457 256,433.399 256,386.153 205.227,372.55 201.994,336.333 156.409,336.333 162.771,407.634",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160 0h55v23h-32v23h32v23h-55z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226 0h55v20h-32v4h32v46h-55v-21h32v-4h-32z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292 0h55v20h-32v4h32v46h-55v-21h32v-4h-32z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.597,176.305 255.843,176.305 255.843,221.716 319.831,221.716 315.699,268.217 255.843,268.217 255.843,313.627 311.761,313.627 306.49,372.521 255.843,386.191 255.843,433.435 348.937,407.634 360.291,280.411",
    fill: "#ffffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgW3CssOfficial);
export default __webpack_public_path__ + "static/media/w3_css-official.abf534f0b1d8057cfaefec85a04f94f0.svg";
export { ForwardRef as ReactComponent };